import styled from 'styled-components';
import { Form as Unform } from '@unform/web';

export const ContainerModal = styled.div`
  background: var(--background-color);
  display: grid;
  padding: 20px;
  place-items: start;
  border-radius: 4px;
  gap: 20px;
`;

export const Title = styled.h1`
  font-size: 3.2rem;
  color: var(--color);
`;

export const Form = styled(Unform)`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  & > div {
    align-self: start;
  }

  @media (max-width: 600px) {
    display: flex;
    flex-direction: column;
  }
`;

export const ButtonContent = styled.div`
  display: flex;
  grid-column: 1 / -1;
  gap: 10px;
`;
